import React from 'react'
import Body from '../components/shpetinas/Body'
import { Intro } from '../components/shpetinas/Intro'

const SHPEtinas = () => {
  return (
    <>
      <Intro/>
      <Body/>
    </>
  )
}

export default SHPEtinas